<template>
	 <div>
			<h2 :class="classe" style="font-weight: bold; text-align: center">Site Seguro</h2>
			<br>
			<v-row justify="center" align="center">
				 <v-col cols="12" sm="12" md="6" lg="6" v-for="(img,index) in imagens" :key="'icones'+index" class="proboximagem">
						<v-card @click="IrParaUrl(img.link)" style="background: transparent; width: 100%; height: 50px;" flat
										class="proboximagemCard">
							 <v-img :src="img.src" style="height: 100%;" contain></v-img>
						</v-card>
				 </v-col>
			</v-row>
	 </div>
</template>

<script>
  import img_4 from './ssl.webp'
  import img_5 from './google_security.webp'

  export default {
    name: 'SiteSeguro',
    props: {
      url: {default: ''},
      classe: {default: ''},
    },
    data: () => ({
      imagens: [
        {
          ico_id: 2,
          src: img_4,
          link: 'https://www.sslshopper.com/ssl-checker.html#hostname=',
          nome: 'ssl'
        },
      ]
    }),
    methods: {
      IrParaUrl(path, target = '_blank') {
        var a = document.createElement('a')
        a.href = path
        a.target = target
        a.click()
      },
    },
    mounted() {
      this.imagens = [
        {
          ico_id: 2,
          src: img_4,
          link: 'https://www.sslshopper.com/ssl-checker.html#hostname=' + this.url,
          nome: 'ssl'
        },
      ]
    },
  }
</script>
